import React from 'react';
import {TextField, CircularProgress, Box ,Grid, Typography} from "@material-ui/core";
import {Table,
        Fecha,
        Accordion,
        AccordionDetails,
        AccordionSummary,
        Loader,
        Loading,
        ExpandMoreIcon,
        objestados,
        regex_solo_numeros,
        usuario_habilitado_sede,
        deshabilitar,
        } from './index.js'

import {useNuevoT1} from '../../hooks/useNuevoT1.js'
import { Button, Spinner } from '@material-tailwind/react';
import Main from '../../../../componentes/Main.js';
import {Fecha as FechaComponent} from '../../../../componentes/Fecha.js'

export const InfoNuevoT1 = ({id,cabecera,setData,usuario,snackbar,puedeEditarse,cambiarStatus})=>{

    const {error,loading,loading2,procesando,datosDelTramite,status_actual_tramite,expanded,
        handleChange,acta_regional,setActa_regional,fechaAR,handleChangeFechaAR,setActa_cdn,fechaACDN,
        handleChangeFechaACDN,inicioActualizacionTramite,actualizarTramite,touched,
        acta_cdn,refrescando} =useNuevoT1(cabecera,id,setData,usuario,snackbar);
   
    if(error){
        return <p>{JSON.stringify(error)}</p>
    }

    if(loading || loading2 || procesando){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
     }

    if(!datosDelTramite){
       
        return <div>
             <Spinner className="h-12 w-12" />
             <p>Cargando solicitud {id}...</p>
        </div>
    }

    return <Box id="solicitud-proceso" sx={{marginRight:'auto',marginLeft:'auto',padding:'5px',borderRadius:'10px',border:'solid 1px gray'}}>
    <Loader open={refrescando}/>
     {status_actual_tramite==objestados.procRegion.nombre && usuario.perfil=='region' && <Accordion expanded={expanded === 'instrucciones'} onChange={handleChange('instrucciones')}>
        <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="instrucciones-content"
        style={{borderBottom:'solid 1px gray',justifyContent:'center',alignItems:'center',background:'rgb(228 228 231)'}}
        id="instrucciones-header"
        >
            <h3>Instrucciones para procesar una solicitud de Nuevo T1</h3> 
        </AccordionSummary>
        <AccordionDetails>
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <Box sx={{textAlign:'left'}}>
                <InstruccionesNuevoT1/>
            </Box>  
        </Grid>
    </Grid>
        </AccordionDetails>
    </Accordion>}
    <Accordion expanded={expanded === 'informacion'} onChange={handleChange('informacion')}>
        <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="informacion-content"
        style={{borderBottom:'solid 1px gray',justifyContent:'center',alignItems:'center',background:'rgb(228 228 231)'}}
        id="informacion-header"
        >
            <h3>Información de TEXTO</h3> 
        </AccordionSummary>
        <AccordionDetails>
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <Box sx={{textAlign:'left'}}>
               <Table className='sol-anexo'>
                    <tbody className='text-sm'>
                        <tr>
                            <td>
                                Texto
                            </td>
                            <td>
                                {datosDelTramite.texto}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Box>  
        </Grid>
    </Grid>
        </AccordionDetails>
    </Accordion>

    <div className='mt-4 grid grid-cols-2 gap-2'>
                <TextField inputProps={{maxLength: 4}} id="dp-documento" 
                value={acta_regional} 
                style={{display: deshabilitar(status_actual_tramite,[objestados.iniciado.nombre],'encontrado') ? 'none' : ''}}
                disabled={deshabilitar(status_actual_tramite,[objestados.procRegion.nombre],'no_encontrado') || usuario.perfil!='region'}
                className='bg-blue-gray-200'
                onChange={(e)=>{
                    if(e.target.value === '' || regex_solo_numeros.test(e.target.value)){
                        setActa_regional(e.target.value)
                    }
                   }} label="Número de acta regional" variant="filled" />
                <FechaComponent  titulo='Fecha de acta regional' 
                        fecha={fechaAR} 
                        style={{marginTop:0}}
                        className='input-ui-data'
                        ocultar={deshabilitar(status_actual_tramite,[objestados.iniciado.nombre],'encontrado')}
                        disabled={deshabilitar(status_actual_tramite,[objestados.procRegion.nombre],'no_encontrado') || usuario.perfil!='region'}
                        setFecha={handleChangeFechaAR}/>  
                   
    </div>

    <div className='mt-4 grid grid-cols-2 gap-2'>
                <TextField inputProps={{maxLength: 4}} id="dp-documento" 
                value={acta_cdn} 
                style={{display: deshabilitar(status_actual_tramite,[objestados.iniciado.nombre,objestados.procRegion.nombre],'encontrado') ? 'none' : ''}}
                disabled={deshabilitar(status_actual_tramite,[objestados.procSede.nombre],'no_encontrado') || !usuario_habilitado_sede(usuario)}
                onChange={(e)=>{
                    if(e.target.value === '' || regex_solo_numeros.test(e.target.value)){
                        setActa_cdn(e.target.value)
                    }
                   }} label="Número de acta CDN" variant="filled" />
                <FechaComponent titulo='Fecha acta CDN' 
                        title={JSON.stringify(fechaACDN)}
                        fecha={fechaACDN}
                        style={{marginTop:0}}
                        className='input-ui-data'
                        ocultar={deshabilitar(status_actual_tramite,[objestados.iniciado.nombre,objestados.procRegion.nombre],'encontrado')}
                        disabled={deshabilitar(status_actual_tramite,[objestados.procSede.nombre],'no_encontrado') || !usuario_habilitado_sede(usuario)}
                        setFecha={handleChangeFechaACDN}/> 
    </div>
   
    <Box sx={{display:'flex',justifyContent:'space-evenly',marginTop:'10px'}}>
        {Object.entries(touched).filter(item=>item[1]==true).length>0 && <Button id="tra-action" onClick={()=>inicioActualizacionTramite(actualizarTramite)}><span className=''>Grabar cambios</span></Button>}
        {!(Object.entries(touched).length > 0) && puedeEditarse && <Button id="tra-action" onClick={cambiarStatus}>Cambiar el estado</Button>}

    </Box>
</Box> 
}

const InstruccionesNuevoT1 = ()=>{
    return <div className='instrucciones'>
        <p> 1 - Definir y completar...</p>
    </div>
}



